import React from "react"
import { useSpacesAction } from "../../actions/useSpacesAction"
import Container from "../../components/Layout/Container"
import { HeadingTitle } from "../../components/Layout/HeadingTitle"
import { HelmetTitle } from "../../components/Layout/HelmetTitle"
import { Loader } from "../../components/Layout/Loader"
import { SearchSortHeader } from "../../components/Layout/SearchSortHeader"
import { Masonry } from "../../components/Masonry"
import Wrapper from "../../components/Layout/Wrapper"
import { SeoTags } from "../../components/Layout/SeoTags"

const SpacesPage = ({ spaces }) => {
  const {
    spaces: paginatedSpaces,
    setSearch,
    loading,
    sort,
    setSort,
    sorts,
    loadingMore,
  } = useSpacesAction(spaces)

  const Elements = () => {
    if (loading) {
      return <Loader />
    }

    return (
      <Masonry
        id="spaces"
        columns={4}
        items={paginatedSpaces.data.map((space) => ({
          to: `/spaces/${space.galleryspaceid}`,
          href: "/spaces/[id]",
          title: space.title,
          subtitle: space.galleryspace.gallery.name,
          image: space.image,
        }))}
      />
    )
  }

  console.log(paginatedSpaces.total)

  return (
    <Wrapper>
      <SeoTags
        title="Spaces | Discover ArtPlacer"
        description="Visualize art pieces and collections in rooms mockups."
        url="https://discover.artplacer.com/spaces"
      />
      <HelmetTitle title="Spaces" />
      <Container>
        <div className="pb-3">
          <HeadingTitle title="Spaces">
            Visualize art pieces and collections in rooms with perspective.
          </HeadingTitle>
        </div>
        <SearchSortHeader
          title={`Total ${paginatedSpaces.total} spaces`}
          hideSearch={false}
          searchPlaceholder="Search room"
          onChangeInput={(val) => setSearch(val)}
          sorts={sorts}
          sort={sort}
          setSort={setSort}
        />
        {paginatedSpaces.total > 0 ? (
          <Elements />
        ) : (
          <p className="noResults">No results match your search.</p>
        )}
        {loadingMore && <Loader />}
      </Container>
    </Wrapper>
  )
}

export default SpacesPage
